var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { PLAY_SMALL_SVG, MORE_SVG, PLAY_SMALL_WHITE_SVG, MORE_WHITE_SVG, PAUSE_SMALL_SVG, PAUSE_SMALL_WHITE_SVG, ARROW_RIGHT_SVG, SERATO_FLIP_ICON_SVG, TR_SYNC_ICON_SVG, BPM_LATINO_LOGO_WHITE_SVG } from "../assets";
import Box from "./Box";
import TagView from "./TagView";
import { AddToHistory, PlayerState } from "../player/types";
import { PlayerContextConsumer } from "../context/player";
import DynamicPlaylist from "../player/DynamicPlaylist";
import PlaybackManager from "../player/PlaybackManager";
import { CrateContextConsumer } from "../context/crate";
import { Loader } from ".";
import { addDnDHandlers } from "./ListViewDragHelper";
import AnimateHeight from 'react-animate-height';
import { messages } from "../messages";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import * as toastr from 'toastr';
import { displayDate } from "../util/date";
var EmptyCommponent = /** @class */ (function (_super) {
    __extends(EmptyCommponent, _super);
    function EmptyCommponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyCommponent.prototype.render = function () { return this.props.children; };
    return EmptyCommponent;
}(React.PureComponent));
var ListView = /** @class */ (function (_super) {
    __extends(ListView, _super);
    function ListView(props) {
        var _this = _super.call(this, props) || this;
        _this.didScrollToTrack = false;
        _this.state = {
            hide: Object.assign({}, ListView.defaultProps.hide, _this.props.hide || {})
        };
        _this.internallist = new DynamicPlaylist([], {
            history_mode: AddToHistory.ALL
        }, _this.props.context, false);
        _this.internallist.replace(_this.props.albums.map(function (album) {
            return {
                album: album,
                track: album.media[0],
                playbackInfo: album.media[0].stream_info,
                playlist: _this.internallist
            };
        }));
        _this.onMediaSelected = _this.onMediaSelected.bind(_this);
        return _this;
    }
    ListView.prototype.scrollToSelected = function () {
        var element = document.getElementsByClassName('col-selected selected')[0];
        element &&
            window.scrollTo({
                top: element.offsetTop - 105,
                behavior: 'smooth'
            });
    };
    ListView.prototype.scrollToItemAndSelect = function () {
        var _this = this;
        if (this.didScrollToTrack) {
            return;
        }
        var hash = location.hash.substring(1);
        if (hash) {
            var expandedItem = this.props.albums.find(function (album) { return album.id.toString() === hash; });
            if (expandedItem) {
                this.didScrollToTrack = true;
                this.setState({ expanded: expandedItem }, (function () {
                    _this.scrollToSelected();
                }));
            }
        }
    };
    ListView.prototype.componentDidMount = function () {
        this.scrollToItemAndSelect();
    };
    ListView.prototype.componentDidUpdate = function (nextProps) {
        var _this = this;
        if (nextProps.albums != this.props.albums) {
            this.internallist.replace(this.props.albums.map(function (album) {
                return {
                    album: album,
                    track: album.media[0],
                    playbackInfo: album.media[0].stream_info,
                    playlist: _this.internallist
                };
            }));
            this.scrollToItemAndSelect();
        }
    };
    ListView.prototype.play = function (shuffle) {
        if (shuffle === void 0) { shuffle = false; }
        PlaybackManager.getInstance().getContentManager().replaceLists(this.internallist);
        PlaybackManager.getInstance().shuffle = shuffle;
        PlaybackManager.getInstance().startTrack(this.internallist.tracks()[0]);
    };
    ListView.prototype.onMediaSelected = function (media, album) {
        PlaybackManager.getInstance().getContentManager().replaceLists(this.internallist);
        PlaybackManager.getInstance().startTrack({
            album: album,
            track: media,
            playbackInfo: media.stream_info,
            playlist: this.internallist
        });
        this.props.onMediaSelected && this.props.onMediaSelected(media, album);
    };
    ListView.prototype.onAlbumSelected = function (album) {
        PlaybackManager.getInstance().getContentManager().replaceLists(this.internallist);
        PlaybackManager.getInstance().startTrack(this.internallist.tracks().find(function (a) { return a.album.id == album.id; }));
        this.props.onAlbumSelected && this.props.onAlbumSelected(album);
    };
    ListView.prototype.onPause = function () {
        PlaybackManager.getInstance().pause();
    };
    ListView.prototype.isAlbumSelected = function (album, playerContext) {
        if (playerContext && playerContext.state >= PlayerState.Loading) {
            return album.media.find(function (m) { return m.id == playerContext.track.track.id; }) != undefined;
        }
        return false;
    };
    ListView.prototype.downloadMedia = function (media, target) {
        var _this = this;
        if (this.props.onMediaDownlod) {
            this.setState({ downloading: media.id });
            this.props.onMediaDownlod(media, false, { target: target, desiredPosition: 'up' }).then(function (downloaded) {
                if (downloaded) {
                    media.download_count += 1;
                }
            }).finally(function () {
                _this.setState({ downloading: undefined });
            });
        }
    };
    ListView.prototype.addToCrate = function (media, target) {
        var _this = this;
        if (this.props.onAddToCrate) {
            this.setState({ addingToCrate: media.id });
            this.props.onAddToCrate(media, { target: target, desiredPosition: 'up' }).finally(function () {
                _this.setState({ addingToCrate: undefined });
            });
        }
    };
    ListView.prototype.removeFromCrate = function (media) {
        var _this = this;
        if (this.props.onRemoveFromCrate) {
            this.setState({ addingToCrate: media.id });
            this.props.onRemoveFromCrate(media).finally(function () {
                _this.setState({ addingToCrate: undefined });
            });
        }
    };
    ListView.prototype.renderMediaRows = function (album, playerContext) {
        var _this = this;
        if (this.props.hide && this.props.hide.mediaRows) {
            return null;
        }
        var expandedClass = ((this.state.expanded && this.state.expanded.id == album.id) ? 'expanded' : '');
        var albumSelected = this.isAlbumSelected(album, playerContext);
        var height = 0;
        if ((this.state.expanded && this.state.expanded.id == album.id)) {
            //expandedClass += ' selected'
            height = 'auto';
        }
        return React.createElement(AnimateHeight, { duration: 500, height: height },
            React.createElement("div", { className: expandedClass },
                React.createElement("div", { className: 'row-item no-hover row-item-tracks audio ' + expandedClass },
                    " ",
                    album.media.map(function (media) {
                        return React.createElement(MediaRow, { key: media.id, album: album, media: media, playerContext: playerContext, onMediaSelected: _this.onMediaSelected, onMediaDownload: function (media, album, target) {
                                _this.downloadMedia(media, target);
                            }, onAddCrate: function (media, target) {
                                _this.addToCrate(media, target);
                            }, onRemoveCrate: function (media) {
                                _this.removeFromCrate(media);
                            }, onPause: _this.onPause, downloading: _this.state.downloading, loaderSize: _this.props.loaderSize || 30, enableDrag: _this.props.enableDrag, context: _this.props.context });
                    }))));
    };
    ListView.renderArtistLink = function (album, onArtistClick) {
        if (album.artist_info) {
            var artist_1 = album.artist;
            var linkArray = album.artist_info.map(function (info, i) {
                artist_1 = artist_1.replace(new RegExp("" + RegExp.escape(info), 'g'), '{ʥ}');
                return {
                    name: info, link: React.createElement("span", { key: info + i, className: 'link', onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            onArtistClick && onArtistClick('audio', info);
                        } }, info)
                };
            }).sort(function (a1, a2) {
                return album.artist.toLowerCase().indexOf(a1.name.toLowerCase()) - album.artist.toLowerCase().indexOf(a2.name.toLowerCase());
            });
            var elements = new Array();
            var match = void 0;
            var re = /{ʥ}/g;
            var index = 0;
            do {
                match = re.exec(artist_1);
                if (match) {
                    if (!linkArray[index]) {
                        break;
                    }
                    elements.push(linkArray[index++].link);
                    elements.push(React.createElement("span", { className: 'artist-link-text', key: match.index }, artist_1.substr(match.index + '{ʥ}'.length).slice(0, artist_1.substr(match.index + '{ʥ}'.length).indexOf('{ʥ}'))));
                }
            } while (match);
            return elements;
        }
        else {
            return React.createElement("span", { className: 'link', onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    onArtistClick && onArtistClick('audio', album.artist);
                } }, album.artist);
        }
    };
    ListView.prototype.renderTrackColumn = function (album) {
        var _this = this;
        return (React.createElement("div", { className: 'col-track' },
            React.createElement("div", { className: 'row-track' },
                React.createElement("div", { className: 'row-track-name' },
                    React.createElement("span", null,
                        album.name,
                        album.exclusive ? React.createElement("span", { className: 'exclusive bpm-exclusive-tag', onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                _this.props.onExclusiveClick && _this.props.onExclusiveClick('audio');
                            } }, "EXCLUSIVE") : null,
                        " "),
                    React.createElement("span", { className: 'serato-tr-container' },
                        album.has_serato_flip && React.createElement("span", { className: 'link', onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                _this.props.onSpeacialTypeClick && _this.props.onSpeacialTypeClick('audio', 'serato');
                            } },
                            React.createElement("img", { width: 18, src: SERATO_FLIP_ICON_SVG })),
                        album.has_tr_sync && React.createElement("span", { className: 'link', onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                _this.props.onSpeacialTypeClick && _this.props.onSpeacialTypeClick('audio', 'tr');
                            } },
                            React.createElement("img", { width: 18, src: TR_SYNC_ICON_SVG })),
                        album.bpm_original && React.createElement("span", { className: 'link', onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                _this.props.onCategoryClick && _this.props.onCategoryClick('audio', album.category.slug);
                            } },
                            React.createElement("img", { width: 18, src: ListView.BPM_ICON })))),
                !this.state.hide.artist && React.createElement("div", { className: 'row-artist' }, ListView.renderArtistLink(album, this.props.onArtistClick)),
                React.createElement("div", { className: 'row-tags' }, album.media.filter(function (m) { return m.tag != undefined; }).map(function (media, i) {
                    return React.createElement(TagView, { id: _this.props.context + '_media_tag_' + media.id.toString(), enableDrag: _this.props.enableDrag, key: media.id, text: media.tag.name, selected: (media.download_count > 0), onSelected: function (elem) {
                            _this.props.onMediaDownlod && _this.props.onMediaDownlod(media, false, { target: elem, desiredPosition: 'right' }).then(function (downloaded) {
                                if (downloaded) {
                                    media.download_count += 1;
                                    _this.forceUpdate();
                                }
                            });
                        }, onAddCrate: function (e) {
                            _this.props.onAddToCrate && _this.props.onAddToCrate(media, { target: e, desiredPosition: 'up' });
                        } });
                })))));
    };
    ListView.prototype.renderArtistColumn = function (album) {
        if (this.props.artistColumn) {
            return React.createElement("div", { className: 'col-artist' }, ListView.renderArtistLink(album, this.props.onArtistClick));
        }
        else {
            return null;
        }
    };
    ListView.prototype.renderCategoryColumn = function (album) {
        var _this = this;
        return React.createElement("div", { className: 'col-category link', onClick: function (e) {
                e.stopPropagation();
                _this.props.onGenreClick && _this.props.onGenreClick('audio', album.genre.slug);
            } }, album.genre.name);
    };
    ListView.prototype.renderCreatedAtColumn = function (album) {
        var _this = this;
        return React.createElement("div", { className: 'col-created_at link', onClick: function (e) {
                e.stopPropagation();
                _this.props.onDateClick && _this.props.onDateClick('audio', new Date(album.created_at));
            } }, displayDate(album.created_at));
    };
    ListView.prototype.renderBPMColumn = function (album) {
        var _this = this;
        return React.createElement("div", { className: 'col-bpm link', onClick: function (e) {
                e.stopPropagation();
                _this.props.onBPMClick && _this.props.onBPMClick('audio', album.bpm);
            } }, album.bpm);
    };
    ListView.prototype.renderKeyColumn = function (album) {
        var _this = this;
        return React.createElement("div", { className: 'col-key link', onClick: function (e) {
                e.stopPropagation();
                _this.props.onKeyClick && album.key && _this.props.onKeyClick('audio', album.key);
            } }, album.key || 'N/A');
    };
    ListView.prototype.renderMoreColumn = function (album) {
        var _this = this;
        if ((this.props.renderer && this.props.renderer.moreColumn)) {
            return this.props.renderer.moreColumn.bind(this)(album, this.state.addingToCrate, this.state.downloading);
        }
        return React.createElement("div", { className: 'col-more', onClick: function (e) {
                e.stopPropagation();
                if (_this.state.expanded && _this.state.expanded.id == album.id) {
                    _this.setState({ expanded: undefined });
                }
                else
                    _this.setState({ expanded: album });
            } },
            React.createElement("div", null,
                React.createElement("img", { src: MORE_SVG, className: 'blue', width: 18 }),
                React.createElement("img", { src: MORE_WHITE_SVG, className: 'white', width: 18 })));
    };
    ListView.prototype.renderSeperator = function (album, playerContext) {
        return React.createElement("div", { className: 'row-item-seperator ' + (this.isAlbumSelected(album, playerContext) ? 'selected' : '') });
    };
    ListView.prototype.renderAudioItem = function (album, playerContext, renderFirstSeperator, index) {
        var _this = this;
        var expanded = ((this.state.expanded && this.state.expanded.id == album.id));
        var albumPlaying = this.isAlbumSelected(album, playerContext);
        return (React.createElement("div", { key: album.id },
            renderFirstSeperator && this.renderSeperator(album, playerContext),
            React.createElement(ContextMenuTrigger, { id: album.id.toString() },
                React.createElement("div", { className: 'row-container' },
                    React.createElement(ContextMenu, { id: album.id.toString() },
                        React.createElement(MenuItem, { data: { foo: 'bar' }, onClick: function () {
                                var el = document.createElement('input');
                                el.setAttribute('style', 'position: absolute; top: -10000px; left: -1000px');
                                document.body.appendChild(el);
                                if (_this.props.shareType == 'hash') {
                                    el.value = "https://" + location.hostname + location.pathname + "#" + album.id;
                                }
                                else {
                                    el.value = "https://" + location.hostname + "/share/" + album.id;
                                }
                                el.select();
                                el.setSelectionRange(0, 99999);
                                document.execCommand("copy");
                                document.body.removeChild(el);
                                toastr.success('Link Copied!');
                            } }, "Share Link")),
                    React.createElement("div", { className: 'col-selected ' + ((expanded) ? 'selected ' : '') }),
                    React.createElement("div", { className: 'row-item row-item-album audio ' +
                            ((expanded) ? 'selected ' : '') +
                            (albumPlaying ? ' playing ' : '') +
                            ((this.state.expanded && this.state.expanded.id == album.id) ? 'expanded ' : '') +
                            (album.approved === false ? ' not-approoved ' : '') +
                            (this.props.hide && this.props.hide.mediaRows ? ' no-cursor ' : ''), onClick: function (e) {
                            e.stopPropagation();
                            if (window.getSelection() && window.getSelection().toString().length > 0) {
                                return;
                            }
                            if (_this.props.hide && _this.props.hide.mediaRows) {
                                return;
                            }
                            if (_this.state.expanded && _this.state.expanded.id == album.id) {
                                _this.setState({ expanded: undefined });
                            }
                            else
                                _this.setState({ expanded: album });
                        } },
                        React.createElement("div", { className: "col-number-play-wrapper cover-art-dimensions" },
                            React.createElement("div", { className: 'number-height-limit cover-art-dimensions' },
                                this.props.hide && this.props.hide.number ? null : React.createElement("div", { className: "col-number" }, index + 1),
                                React.createElement("div", { className: "col-play " + (this.props.hide && this.props.hide.number ? 'always-show' : '') }, (this.props.renderer && this.props.renderer.playColumn) ? this.props.renderer.playColumn.bind(this)(album, playerContext) : React.createElement("span", { onClick: function (e) {
                                        e.stopPropagation();
                                        if (playerContext.state >= PlayerState.Loading && albumPlaying) {
                                            _this.onPause();
                                        }
                                        else {
                                            _this.onAlbumSelected(album);
                                        }
                                    } },
                                    !albumPlaying && React.createElement("div", { className: 'play' },
                                        React.createElement("img", { src: PLAY_SMALL_SVG, className: 'play blue', width: ListView.DefaultPlayPauseSize }),
                                        React.createElement("img", { src: PLAY_SMALL_WHITE_SVG, className: 'play white', width: ListView.DefaultPlayPauseSize })),
                                    albumPlaying && React.createElement("div", { className: 'pause' },
                                        React.createElement("img", { src: PAUSE_SMALL_SVG, className: 'pause blue', width: ListView.DefaultPlayPauseSize }),
                                        React.createElement("img", { src: PAUSE_SMALL_WHITE_SVG, className: 'pause white', width: ListView.DefaultPlayPauseSize })))))),
                        React.createElement("div", { className: "cover-art cover-art-dimensions" },
                            React.createElement("img", { className: "cover-art-dimensions", src: album.cover, alt: "cover art" })),
                        this.renderTrackColumn(album),
                        this.renderArtistColumn(album),
                        this.renderCategoryColumn(album),
                        this.renderCreatedAtColumn(album),
                        this.renderBPMColumn(album),
                        this.renderKeyColumn(album),
                        this.renderMoreColumn(album)))),
            this.renderMediaRows(album, playerContext),
            this.renderSeperator(album, playerContext)));
    };
    ListView.prototype.renderVideoItem = function (album, playerContext, renderFirstSeperator, index) {
        var _this = this;
        var albumPlaying = this.isAlbumSelected(album, playerContext);
        var expanded = ((this.state.expanded && this.state.expanded.id == album.id));
        return (React.createElement("div", { key: album.id },
            renderFirstSeperator && this.renderSeperator(album, playerContext),
            React.createElement("div", { className: 'row-container' },
                React.createElement("div", { className: 'col-selected ' + ((expanded) ? 'selected ' : '') }),
                React.createElement("div", { className: 'row-item  row-item-album video ' +
                        ((expanded) ? 'selected ' : '') +
                        (albumPlaying ? ' playing ' : '') +
                        ((this.state.expanded && this.state.expanded.id == album.id) ? 'expanded ' : '') +
                        (album.approved === false ? ' not-approoved ' : '') +
                        (this.props.hide && this.props.hide.mediaRows ? ' no-cursor ' : ''), onClick: function (e) {
                        e.stopPropagation();
                        if (_this.props.hide && _this.props.hide.mediaRows) {
                            return;
                        }
                        if (_this.state.expanded && _this.state.expanded.id == album.id) {
                            _this.setState({ expanded: undefined });
                        }
                        else
                            _this.setState({ expanded: album });
                    } },
                    React.createElement("div", { className: 'col-play' }, React.createElement("span", { onClick: function (e) {
                            e.stopPropagation();
                            if (playerContext.state >= PlayerState.Loading && albumPlaying) {
                                _this.onPause();
                            }
                            else {
                                _this.onAlbumSelected(album);
                            }
                        } },
                        React.createElement("div", { className: albumPlaying ? 'pause' : 'play' },
                            album.image && React.createElement("img", { src: album.image, className: 'thumbnail' }),
                            React.createElement("div", { className: 'thumbnail-action' })))),
                    this.renderTrackColumn(album),
                    this.renderArtistColumn(album),
                    this.renderCategoryColumn(album),
                    this.renderCreatedAtColumn(album),
                    this.renderBPMColumn(album),
                    this.renderKeyColumn(album),
                    this.renderMoreColumn(album))),
            this.renderMediaRows(album, playerContext),
            this.renderSeperator(album, playerContext)));
    };
    ListView.prototype.render = function () {
        var _this = this;
        var title = typeof this.props.title == 'function' ? this.props.title(this.props.albums) : this.props.title;
        var subTitle = this.props.subTitle;
        var BoxContainer = this.props.noBox ? EmptyCommponent : Box;
        return (React.createElement("div", { style: this.props.style, className: this.props.className },
            React.createElement(BoxContainer, null,
                React.createElement("div", { className: "listview" },
                    Boolean(title) && React.createElement("div", { className: 'head-listview-title' },
                        React.createElement("h3", { className: 'header-title my-auto' }, title),
                        React.createElement("div", { className: 'header-date my-auto' }, this.props.lastUpdated ? ('Last Update: ' + displayDate(this.props.lastUpdated)) : '')),
                    subTitle && React.createElement("div", { className: "head-listview-subtitle" }, subTitle),
                    React.createElement("div", { className: 'table-media' }, this.props.albums.map(function (album, i) {
                        if (_this.props.contentType == 'audio' || (_this.props.contentType == 'mixed')) {
                            return (React.createElement(PlayerContextConsumer, { key: album.id }, function (value) {
                                return _this.renderAudioItem(album, value, i == 0 && !_this.state.hide.firstSeperator, i);
                            }));
                        }
                        else {
                            return (React.createElement(PlayerContextConsumer, { key: album.id }, function (value) {
                                return _this.renderVideoItem(album, value, i == 0 && !_this.state.hide.firstSeperator, i);
                            }));
                        }
                    })),
                    !this.state.hide.viewAll && React.createElement("div", { className: 'view-all-container' },
                        React.createElement("span", { onClick: function () { return _this.props.onViewMoreClick && _this.props.onViewMoreClick(); } },
                            React.createElement("span", null,
                                messages.ViewAll,
                                " ",
                                React.createElement("img", { src: ARROW_RIGHT_SVG, height: 17 })))),
                    this.state.hide.viewAll && React.createElement("div", { className: 'pagination-container' }, this.props.renderPager && this.props.renderPager())))));
    };
    ListView.DefaultPlayPauseSize = 7;
    ListView.BPM_ICON = BPM_LATINO_LOGO_WHITE_SVG;
    ListView.defaultProps = {
        hide: {
            viewAll: true,
            firstSeperator: true
        }
    };
    return ListView;
}(React.Component));
export default ListView;
var MediaRow = function (_a) {
    var album = _a.album, media = _a.media, playerContext = _a.playerContext, onMediaSelected = _a.onMediaSelected, onPause = _a.onPause, downloading = _a.downloading, onMediaDownload = _a.onMediaDownload, loaderSize = _a.loaderSize, addingToCrate = _a.addingToCrate, onRemoveCrate = _a.onRemoveCrate, onAddCrate = _a.onAddCrate, enableDrag = _a.enableDrag, context = _a.context;
    var mediaSelected = false;
    if (playerContext.track && playerContext.state >= PlayerState.Loading) {
        mediaSelected = playerContext.track.track.id == media.id;
    }
    return (React.createElement("div", { key: media.id },
        React.createElement("div", { id: context + '_media_' + media.id.toString(), draggable: enableDrag, ref: function (e) {
                if (e) {
                    addDnDHandlers(e);
                    e.addEventListener('add_to_crate', function () {
                        onAddCrate(media, e);
                    });
                }
            }, className: 'row-expanded-track ' + (mediaSelected ? 'selected' : ''), onClick: function () { onMediaSelected(media, album); } },
            React.createElement("div", { className: 'col-play' }, React.createElement("span", { onClick: function (e) {
                    if (playerContext.state >= PlayerState.Loading && mediaSelected) {
                        e.stopPropagation();
                        onPause();
                    }
                } },
                !mediaSelected && React.createElement("div", { className: 'play' },
                    React.createElement("img", { src: PLAY_SMALL_SVG, className: 'play blue', width: ListView.DefaultPlayPauseSize }),
                    React.createElement("img", { src: PLAY_SMALL_WHITE_SVG, className: 'play white', width: ListView.DefaultPlayPauseSize })),
                mediaSelected && React.createElement("div", { className: 'pause' },
                    React.createElement("img", { src: PAUSE_SMALL_SVG, className: 'pause blue', width: ListView.DefaultPlayPauseSize }),
                    React.createElement("img", { src: PAUSE_SMALL_WHITE_SVG, className: 'pause white', width: ListView.DefaultPlayPauseSize })))),
            React.createElement("div", { className: "col-track" },
                React.createElement("div", { className: 'row-track' },
                    React.createElement("div", { className: 'row-track-name' },
                        React.createElement("span", null, media.name)))),
            React.createElement("div", { className: 'col-download' },
                React.createElement("div", { className: "row-download " + (downloading && downloading == media.id ? 'downloading' : '') },
                    React.createElement("div", { className: "downloaded " + (media.download_count > 0 ? 'selected' : ''), onClick: function (e) {
                            e.stopPropagation();
                            if (media.download_count == 0) {
                                onMediaDownload(media, album, e.currentTarget);
                            }
                        } }),
                    React.createElement("div", { className: "downloaded " + (media.download_count > 1 ? 'selected' : ''), onClick: function (e) {
                            e.stopPropagation();
                            if (media.download_count <= 1) {
                                onMediaDownload(media, album, e.currentTarget);
                            }
                        } }),
                    React.createElement("div", { className: "downloaded " + (media.download_count > 2 ? 'selected' : ''), onClick: function (e) {
                            e.stopPropagation();
                            if (media.download_count <= 2) {
                                onMediaDownload(media, album, e.currentTarget);
                            }
                        } }),
                    React.createElement("div", { className: "download", onClick: function (e) {
                            e.stopPropagation();
                            onMediaDownload(media, album, e.currentTarget);
                        } }, downloading && downloading == media.id && React.createElement(Loader, { size: loaderSize })),
                    React.createElement(CrateContextConsumer, null, function (crate) {
                        return React.createElement("div", { className: "add-to-crate " + (crate.find(function (item) { return item.media[0].id == media.id; }) == undefined ? 'add ' : 'remove ') + ((addingToCrate && addingToCrate == media.id) ? 'adding' : ''), onClick: function (e) {
                                e.stopPropagation();
                                if (crate.find(function (item) { return item.media[0].id == media.id; }) == undefined) {
                                    onAddCrate(media, e.currentTarget);
                                }
                                else {
                                    onRemoveCrate(media);
                                }
                            } }, addingToCrate && addingToCrate == media.id && React.createElement(Loader, { size: loaderSize }));
                    }))))));
};
//# sourceMappingURL=ListView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/ListView.js
// module id = 434
// module chunks = 0